import TokenService from './token.service';

export default TokenService;
